import { useSelector } from "react-redux";

export function useFeatureChecker() {
  const { currentOrganizationFeatures } = useSelector(
    state => state.organizationFeatures
  );

  return feature_name => {
    if (!(currentOrganizationFeatures instanceof Array)) {
      return false;
    }

    return currentOrganizationFeatures.some(
      ({ name, is_active }) => feature_name === name && is_active
    );
  };
}
